export default __webpack_public_path__ + "static/media/certification_pink.590be34f.svg";